import './ProductItem.css'
import React from 'react'
import { Link } from 'react-router-dom'
import { config } from '@config'
import { useSelector } from 'react-redux'
import { ProductStatus } from './ProductView'
import ProductIcon3PMS from './ProductIcon3PMS'
import ProductNote from './ProductNote'
import { Alert } from 'antd'

export default function ProductItem({
    product,
    onClick,
    link
}) {

    const user = useSelector((state) => state.user.userinfo)
    // const localtionId = user ? (product?.location || 0) : 0
    const localtionId = product?.location || 0
    let textLessFour = product?.count === 4 ?
        'Note: This item is the last set (4 pieces) and is a clearance item.' :
        `Note: This item is the last ${product?.count} pieces and is a clearance item.`
    return (
        <>
            <div className="product-item">
                <div className="item-img flex items-center justify-center">
                    <ProductIcon3PMS product={product} />
                    {product.pictures && (
                        <Link to={link} onClick={onClick}>
                            <img className='item-img-product' src={product.pictures.split(',')[0]} alt={product.title} />
                        </Link>
                    )}
                    {!product.pictures && product.pattern_picture && (
                        <Link to={link} onClick={onClick}>
                            <img className='item-img-product' src={product.pattern_picture} alt={product.title} />
                        </Link>
                    )}
                    {/* <div className='absolute top-0 left-0 bg-black text-white px-2 text-[14px]'>
                        {product.type_name}
                    </div> */}
                </div>
                <div className="product-item-content !gap-2">
                    <h3 className='leading-6'>
                        <Link className='font-bold' to={link} onClick={onClick}>
                            {(product.width && product.profile && product.rim) ? `${product.width}/${product.profile}R${product.rim} ${product.brands}` : product.title}
                        </Link>
                    </h3>
                    <h4 className='leading-5 hidden'>
                        {product.title}
                    </h4>
                    <p className='leading-4'>{product.description}</p>
                    {product.status_type > 0 &&
                        // <span className={currentRow.status_type === 1 ? 'status_on_sale' : 'status_on_clear'}>{product.status_type === 1 ? 'On Sale' : 'On Clearance'}</span>
                        <span className={ProductStatus[product.status_type - 1].className}>{ProductStatus[product.status_type - 1].name}</span>
                    }
                    <div className='product-price'>
                        <h4><span className='font-bold'>(Tire Price) Retail: </span>${Number(product.retail_price)}</h4>
                        {user && user.is_view && (
                            <>
                                {Number(product.price) > 0 && (
                                    <h4 className='product-price-partner'>Partner: ${Number(product.price)}</h4>
                                )}
                                {user.is_vip && Number(product.vip_price) > 0 ?
                                    (<h4 className='product-price-vip'>VIP: ${Number(product.vip_price)}</h4>
                                    ) : null}
                            </>
                        )}
                    </div>
                    {user && user.is_view && (
                        <p>
                            <strong>For shop:</strong><br />
                            Price does not include: tire recycling fee <font color='red'>($5 per tire)</font>; delivery fee <font color='red'>(varies by distance)</font>; credit card fee <font color='red'>(2%)</font>
                            <br />
                            Certain sizes cannot break set of four.
                        </p>
                    )}
                    {product.count !== 0 && ((user && product.status_visible !== 1) || product.count <= 4) && (
                        <h4><span className='font-bold'>Quantity:</span> {product.count >= 16 ? '16+' : product.count}</h4>
                    )}
                    {product.count !== 0 && product.count <= 4 && (
                        <Alert message={textLessFour} type="error" />
                    )}
                    <h4><span className='font-bold'>Location: </span>{config.location[localtionId]}</h4>
                    {product?.tread_depth && (
                        <h4><span className='font-bold'>Tread Depth:</span> {product.tread_depth} <span style={{
                            fontSize: '12px',
                            fontWeight: 400
                        }}>(32nd inch)</span></h4>
                    )}
                    {product.tags && (
                        <h4><span className='font-bold'>Tags:</span> {product.tags}</h4>
                    )}
                    {/* <ProductNote /> */}
                    <div className='product-item-btns smsize:items-center smsize:justify-center'>
                        {/* <button className="common-button">Add to Cart</button> */}
                        <Link to={link} onClick={onClick} className="view-detail">
                            <button className="common-button">View Details</button>
                        </Link>
                    </div>
                </div>
            </div>

        </>
    )
}
